import { Route, Routes } from "react-router";
import Login from "./login";
import AdminHome from "./admin/adminhome";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/admin/*" element={<AdminHome/>} />
      </Routes>
    </>    
  );
}
export default App;
